import Vue from 'vue'

const api = () => Vue.prototype.$api

export default {
  getDiseasesByName ({ name, onlyCIE, specialtyId, hideLoadingIcon }) {
    return api().get('diseases', { params: { name, specialtyId, onlyCIE }, loading: !hideLoadingIcon })
  },
  getProfDiseases ({name, hideLoadingIcon}) {
    return api().get('professional/diseases', { params: { name: name }, loading: !hideLoadingIcon })
  },
  getCenterDiseases ({name, hideLoadingIcon}) {
    return api().get('center/diseases', { params: { name: name }, loading: !hideLoadingIcon })
  }
}


// WEBPACK FOOTER //
// ./src/repositories/DiseasesRepository.js